import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { forgotUsername } from '../redux/modules/user/actions';
import CommonAuthComponent from './CommonAuthComponent';
import CustomInput from '../components/common/CustomInput';
import { isValidPhoneNumber } from '../helpers/input-validations';

const ForgotUsername = () => {
  const [email, setEmail] = useState('');
  const [drivingLicense, setDrivingLicense] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { forgotUsernameLoading } = useSelector((state) => state.users);

  const isFormValid = email && drivingLicense && phoneNumber && isValidPhoneNumber(phoneNumber);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const phoneValid = isValidPhoneNumber(phoneNumber);
    setPhoneNumberError(!phoneValid);
    if (email && drivingLicense && phoneNumber && phoneValid) {
      dispatch(forgotUsername({ email, drivingLicense, phoneNumber }, navigate));
    }
  };

  return (
    <CommonAuthComponent>
      <h1 className="text-[22px] text-center mb-[10px] font-medium leading-[30px]">
        Forgot Your Username?
      </h1>

      <p className="text-center text-[16px] font-normal leading-[22px] mb-10">
        Provide the Key Identifiers 
      </p>

      <form onSubmit={handleSubmit}>
        <CustomInput
          label="Registered Email Address"
          placeholder="Enter Registered Email Address"
          inputClassName="bg-transparent"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className='bg-white mb-4'
        />

        <CustomInput
          label="Driving License Number"
          placeholder="Enter Driving License Number"
          inputClassName="bg-transparent"
          name="drivingLicense"
          type="text"
          value={drivingLicense}
          onChange={(e) => setDrivingLicense(e.target.value)}
          required
          className='bg-white mb-4'
        />

        <CustomInput
          label="Phone Number"
          placeholder="(555) 000-0000"
          inputClassName="bg-transparent"
          name="phoneNumber"
          type="phone"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          error={phoneNumberError}
          required
          className='bg-white mb-8'
        />

        <button
          type="submit"
          disabled={forgotUsernameLoading || !isFormValid}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5
            bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
        >
          {forgotUsernameLoading ? (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
          ) : null}
          {forgotUsernameLoading ? 'Searching...' : 'Continue'}
        </button>
      </form>

      <div className="mt-4 text-center">
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border-[1px] border-REELTeal transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5 hover:bg-teal-75"
        >
          Back to Log-In
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default ForgotUsername;
